import React, { Component } from "react";
import { Link,Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";
import { withTranslation } from "react-i18next";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { Row, Col, Container, Button } from "react-bootstrap";
import ReactRecaptcha3 from 'react-google-recaptcha3';
import queryString from "query-string";
import WithError from "../common/WithError";
import { setCookie } from "../../utils/cookies";
import RightArrow from "../../assets/images/right-arrow-white.svg";
import Carousel1 from "../../assets/images/MFA-Background-001.png";
import Carousel2 from "../../assets/images/MFA-Background-002.png";
import Carousel3 from "../../assets/images/MFA-Background-003.png";
import Carousel4 from "../../assets/images/MFA-Background-004.png";
import Carousel5 from "../../assets/images/MFA-Background-005.png";
import Carousel6 from "../../assets/images/MFA-Background-006.png";
import Carousel7 from "../../assets/images/MFA-Background-007.png";
import Carousel9 from "../../assets/images/reg9.jpg";
import CopyIcon from "../../assets/images/copy-text-icon.svg";
import downChevron from '../../assets/images/down-chevron.svg';
import NewTabIcon from "../../assets/images/new-tab.svg";
import ReactCodeInput from 'react-verification-code-input';
import QRCode from 'qrcode.react';
import Radio from "../common/Radio";
import http from "../../api/http-request";
import SomethingWentWrong from "../common/SomethingWentWrong";
import SystemDownTime from "../common/SystemDownTime";
import {FRDevice} from "@forgerock/javascript-sdk";
import validator from "validator";

import {
  getRoutePath,
  getNestedObject,
  removeAllStorageValues,
  getLocalStorageValue,
  removeLocalStorageValue,pageNotFound,randomCount,preventNonDigitCharacters,getPhoneNumberFromFormattedString,formatPhoneNumber
} from "../../utils/common";
import Checkbox from "../common/Checkbox";

class Login extends Component {
  constructor(props) {
    super(props);
    this.mobileNumberInputRef = React.createRef();
    this.verificationInputRef = React.createRef();
    this.state = {
      showPassword: false,
      errorText: "",
      userName: "",
      password: "",
      isAuthenticated: false,
      loginPayLoad: {},
      verificationPayLoad:{},
      appendParamsToApiUrl: true,
      isSystemError:false,
      isSomethingError:false,
      carouselImages: [{'image':Carousel3},{'image':Carousel4},{'image':Carousel5},{'image':Carousel1},{'image':Carousel2},{'image':Carousel6},{'image':Carousel7},{'image':Carousel9}],
      imageIndex:null,
      verificationCode: "",
      screen: 1,
      mobileNumber:'',
      mobileNumberUSFormatted: "",
      screenWithSkip:false,
      verificationOption:"",
      loginAttempts:false,
      loginAttemptsCount:"",
      loginLastAttempts:false,
      verificationPlaceholder:['0','0','0','0','0','0','0','0'],
      serviceType:"",
      switchMethod: false,
      changeMethod: "",
      captchaSiteKey:"",
      authenticateChoice:"",
      smsChoice:"",
      phoneChoice:"",
      emailChoice:"",
      selectedChoice:"0",
      qrCodeUrl:"",
      aplhaNumericCode:"",
      authOtpAttempt:0,
      mfaReg:"",
      prefMfa:"",
      requiresMfa:false,
      userNameInvalid:false,
      passwordInvalid:false,
      userNameError:"",
      passwordError:"",
      rememberDevice:false,
      showCheckbox:false,
      seeMore:false,
      phoneSuccess:false,
      rememberDeviceCheckbox:true
    };
  }

  componentDidMount() {
    const isloggedIn = getLocalStorageValue("isUserLogin");
    window.scrollTo(0, 0);
    removeAllStorageValues();
    const {
      location: { search },
    } = this.props;
    this.displayRandomImage();
    const params = queryString.parse(search);
    if (!params.logoutStatus && getLocalStorageValue("backTo")) {
      removeLocalStorageValue("backTo");
    }
    let ctAppSource;
    const locationUrl = window.location.origin;
    if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
      ctAppSource = 'ctapproutedev';
    } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
      ctAppSource = 'ctapproutestg';
    } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
      ctAppSource = 'ctapproutedevc';
    } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
      ctAppSource = 'ctapproutepsup';    
    } else if (locationUrl.indexOf('login.ct.gov') > 0) {
      ctAppSource = 'ctapproute';
    }
    if (params.goto || params.spEntityID) {
      if (params.service) {
        const serviceType = `&authIndexType=service&authIndexValue=${params.service}`;
        setCookie(`${ctAppSource}`, `${search}${serviceType}`);
        this.setState({
          serviceType: params.service,
        });
      } else {
        setCookie(`${ctAppSource}`, search);
        this.setState({
          serviceType:"",
        });
      }
    }
    this.setState(
      {
        appendParamsToApiUrl: !params.logoutStatus,
      },
      () => {
        this.isAuthenticate();
      }
    );
  }

  displayRandomImage = () => {
    this.setState({
      imageIndex: randomCount(),
    });
  };

  isAuthenticate = () => {
    http(
      {
        url: this.getAuthenticateUrl(),
        method: "POST"
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      if (res.status === 200 && res.data && (res.data.authId || res.data.tokenId)) {
        if (getNestedObject(res, ["data", "successUrl"])) {
          window.location.href = sanitizeUrl(`${res.data.successUrl}`);
        } else if (getNestedObject(res, ["data"])) {
          this.genericResponse(res);
        }
      }
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else if(res.status === 404 || res.status === 503){
        this.setState({
          isSystemError : true,
        });
      } 
      else {
        this.setState({
          isSomethingError : true,
        });
      }
    });
  };

  showPassword = () => {
    this.setState((state) => ({
      showPassword: !state.showPassword,
    }));
  };

  resendOTP = (e) => {
    e.preventDefault();
    const { verificationPayLoad } = this.state;
    verificationPayLoad.callbacks[3].input[0].value = 1;
    this.verificationInputRef.current.__clearvalues__();
    this.setState({
      verificationCode:"",
      verificationCodeError:"",
    });

    http(
      {
        url: this.getAuthenticateUrl(),
        method: "POST",
        data: verificationPayLoad
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      this.genericResponse(res);
    });
  };

  loginAttempts = (res) => {
    if(res.data.callbacks[5]){
      if(res.data.callbacks[5].output[0].value === "LOGIN_COUNT_IGNORE"){
        this.setState({
          loginAttempts:false,
        })
      }
      else if(res.data.callbacks[5].output[0].value !== "LOGIN_COUNT_IGNORE" && res.data.callbacks[5].output[0].value > 0){
        this.setState({
          loginAttempts:true,
          loginAttemptsCount:res.data.callbacks[5].output[0].value
        })
      }else if(res.data.callbacks[4].output[0].value === 'EMAIL_NOT_VERIFIED'){
        this.setState({
          loginLastAttempts:false
        })
      }else if(res.data.callbacks[4].output[0].value === 'MFA_ENROLLED_TRUE'){
        this.setState({
          loginLastAttempts:false
        })
      }
      else {
        this.setState({
          loginLastAttempts:true
        })
      }
    }
    if(res.data.callbacks[5]){
      if(res.data.callbacks[5].output[0].value === "OTP_VALIDATION_FAILED" || res.data.callbacks[4].output[0].value === 'OTP_VALIDATION_FAILED'){
        this.setState({
          verificationCodeError: "pages.editEmailAddressPopup.invalidOTP"
        });
      }
    }
    if(res.data.callbacks[3]){
      if(res.data.callbacks[3].output[0].value === "INVALID_NUMBER"){
        this.setState({
          mobileNumberError: "pages.editNumberPopup.invalidNumber"
        });
      }
    }
  }
  genericResponse = (res) => {
    const {location:{search}} = this.props;
    const params = queryString.parse(search);
    if (getNestedObject(res, ["data", "successUrl"])) {
      window.location.href = sanitizeUrl(`${res.data.successUrl}`);
    } 
    else if(getNestedObject(res, ["data", "callbacks"])) {
      
      const {
        data: {
          callbacks
        }
      } = res;
      if(callbacks){
        this.loginAttempts(res);
        if(callbacks[0].output[0].value === 'OTP_COLLECTOR'){
          let reqmfa=false;
          if(callbacks[4].output[0].value === 'APP_REQUIRES_MFA'){
            reqmfa=true;
          }
          this.setState({
            screen: 2,
            verificationPayLoad:res.data,
            verificationOption:res.data.callbacks[1].output[0].value,
            isAuthenticated:true,
            screenWithSkip: false,
            switchMethod: false,
            requiresMfa:reqmfa ? reqmfa : this.state.requiresMfa,
            loginAttempts:reqmfa ? false : this.state.loginAttempts,
            loginLastAttempts:reqmfa ? false : this.state.loginLastAttempts,
            showCheckbox:callbacks[4].output[0].value === 'MFA_ENROLLED_TRUE' ? true : false
          });
          this.checkRememberDevice(params);
        }
        else if(callbacks[0].output[0].value === 'OTP_COLLECTOR_MFA_CHOICE' || callbacks[0].output[0].value === 'OTP_COLLECTOR_MFA'){
          this.setState({
            screen: 6,
            verificationPayLoad:res.data,
            verificationOption:res.data.callbacks[1].output[0].value,
            isAuthenticated:true,
            screenWithSkip: false,
            switchMethod: false,
            changeMethod: res.data.callbacks[1].output[0].value.includes("@") ? "PHONE" : "EMAIL"
          });
          if(callbacks[0].output[0].value === 'OTP_COLLECTOR_MFA_CHOICE') {
            this.setState({
              switchMethod: true,
              showCheckbox:true
            });
          }
          this.checkRememberDevice(params);
        }
        else if(callbacks[0].output[0].value === 'User Name' && callbacks[0].type === 'NameCallback') {
          //const siteKey = callbacks[2].output[0].value;
          this.setState({ loginPayLoad: res.data, isAuthenticated: true});
          if(callbacks[2] && callbacks[2].type == "ReCaptchaCallback")
          {
            const siteKey = callbacks[2].output[0].value
            this.setState(
              {
                captchaSiteKey: callbacks[2].output[0].value,
              },
            );
            ReactRecaptcha3.init(siteKey).then((status) => {
              console.log(status);
            });
          }
        }
        else if(callbacks[0].output[0].value === 'OTP_COLLECTOR_SKIP'){
          this.setState({
            screen: 2,
            screenWithSkip:true,
            verificationPayLoad:res.data,
            verificationOption:res.data.callbacks[1].output[0].value,
            isAuthenticated:true,
            switchMethod: false,
            rememberDeviceCheckbox:false
          });
          
        }
        else if(callbacks[0].output[0].value === 'CHOOSE_PHONE_EMAIL'){
          
          this.setState({
            screen: 5,
            verificationPayLoad:res.data,
            screenWithSkip:false,
            userEmail: res.data.callbacks[1].output[1].value[0],
            userPhone: res.data.callbacks[1].output[1].value[1],
            isAuthenticated:true,
            switchMethod: false
          });
          
        }
        else if(callbacks[0].output[0].value === 'TELEPHONENUMBER_COLLECTOR'){
          
          this.setState({
            screen: 3,
            verificationPayLoad:res.data,
            isAuthenticated:true
          });
        }
        else if(callbacks[0].output[0].value === 'VERIFY_PHONE'){
          
          this.setState({
            screen: 4,
            verificationPayLoad:res.data,
            isAuthenticated:true
          });
        }else if(callbacks[0].output[0].value === 'MFA_REGISTRATION_PROMPT'){ 
          this.setState({
            screen: 7,
            verificationPayLoad:res.data,
            isAuthenticated:true
          });
        } else if(callbacks[0].output[0].value === 'MFA_REGISTRATION_CHOICE' || callbacks[0].output[0].value === 'MFA_USER_CHOICE_PROMPT'){
          const choices =callbacks[0].output[1].value;
          let reqmfa;
          choices.forEach((element,index) => {
            this.checkChoices(element,index);
          });
          if(callbacks[0].output[0].value === 'MFA_USER_CHOICE_PROMPT'){
            if(callbacks[1].output[0].value === 'APP_REQUIRES_MFA'){
              reqmfa = true;
            }
          }
          this.setState({
            screen: 8,
            verificationPayLoad:res.data,
            isAuthenticated:true,
            screenWithSkip:callbacks[0].output[0].value === 'MFA_REGISTRATION_CHOICE',
            authOtpAttempt:0,
            requiresMfa:reqmfa ? reqmfa : this.requiresMfa
          });
        } else if(callbacks[0].output[0].value === 'AUTHENTICATOR_PROMPT'){ 
          this.setState({
            screen: 9,
            verificationPayLoad:res.data,
            isAuthenticated:true
          });
        } else if(callbacks[0].type === "DeviceProfileCallback"){
          this.setState({
            verificationPayLoad:res.data
          })
          this.deviceCheck();
        } else if(callbacks[0].output[0].value.includes('Scan the QR code')){
          let splitCode;
          if(callbacks[2].output[0].value.includes('secret')){
            splitCode = callbacks[2].output[0].value.split('=');
          }
          this.setState({
            screen:10,
            verificationPayLoad:res.data,
            isAuthenticated:true,
            qrCodeUrl:callbacks[2].output[0].value,
            aplhaNumericCode:splitCode[1]
          });
          
        } else if(callbacks[0].output[0].value === 'Enter verification code'){
            this.setState({
              switchMethod:callbacks[1].output[2].value.length > 1 ? true:false,
              screen:11,
              verificationPayLoad:res.data,
              isAuthenticated:true,
              authOtpAttempt:this.state.authOtpAttempt + 1,
              rememberDeviceCheckbox:callbacks[1].output[2].value.length > 1 ? true:false 
            });
            this.checkRememberDevice(params);
        } else if(callbacks[0].output[0].value === 'SAVE_DEVICE_PROMPT'){
            this.setState({
              verificationPayLoad:res.data,
              verificationCodeError:""
            })
            this.saveDeviceHandler()
        } else if(callbacks[0].output[0].value === 'MFA_REGISTRATION_CONFIRMATION'){
          let prefMode;
          switch (callbacks[2].output[0].value){
            case "EMAIL":
              prefMode = "pages.login.prefEmail";
              break;
            case "SMS":
              prefMode = "pages.login.prefSms";
              break;
            case "CALL":
              prefMode = "pages.login.prefCall";
              break;
            case "AUTHENTICATOR":
              prefMode = "pages.login.prefAuth";
              break;
            default :
              prefMode = "";
          }
          this.setState({
            screen:12,
            verificationPayLoad:res.data,
            isAuthenticated:true,
            mfaReg:callbacks[1].output[0].value,
            prefMfa:prefMode
          })
      } else if(callbacks[0].output[0].value === 'PROGRESSIVE_PROFILING_CONFIRMATION'){
        if(callbacks[1].output[0].value === 'FAILURE'){
          this.setState({
            screen:13,
            phoneSuccess:false,
            verificationPayLoad:res.data
          })
        }else{
          this.setState({
            screen:13,
            phoneSuccess:true,
            verificationPayLoad:res.data
          })
        }
      } else {
          this.showError("common.errors.loginApiError");
        }

      } 
    }
    else if (getNestedObject(res, ["data", "detail", "failureUrl"])) {
      const {
        data: {
          detail: { failureUrl }
        }
      } = res;
      if (failureUrl.includes("https://")) {
        window.location.href = sanitizeUrl(`${res.data.detail.failureUrl}`);
        return;
      }
      let errorMsg = "";
      switch (failureUrl) {
        case "INVALID_CREDENTIALS":
          errorMsg = "common.errors.wrongCredentials";
          break;
        case "ACCOUNT_LOCKED":
          errorMsg = "common.errors.accountLocked";
          break;
        case "ACCOUNT_ALREADY_LOCKED":
          errorMsg = "common.errors.accountAlreadyLocked";
          break;
        case "INTERNAL_ERROR":
          errorMsg = "common.errors.internalError";
          break;
        case "MAX_RETRY_EXCEEDED":
          errorMsg = "common.errors.maxVerifyAttempt";
          break;
        case "MAX_RESEND_EXCEEDED":
          errorMsg = "common.errors.maxResendAttempt";
          break;
        case "MAX_SWITCH_EXCEEDED":
          errorMsg = "common.errors.maxSwitchAttempt";
          break;
        case "RELOAD_PAGE":
          errorMsg = "common.errors.reloadPage";
          break;
        default:
          errorMsg = "common.errors.internalError";
          break;
      }
      this.showError(errorMsg);
      if(errorMsg === 'MAX_RETRY_EXCEEDED' || errorMsg === 'MAX_RESEND_EXCEEDED') {
        this.setState({
          screen:1,
          verificationCode:"",
          userName: "",
          password: ""
        });
      } else if(failureUrl === 'MAX_SWITCH_EXCEEDED'){
        this.setState({
          screen:1,
          verificationCode:"",
          userName:"",
          password:"",
          authOtpAttempt:0
        })
      }
     else {
      this.setState({
        screen:1,
        verificationCode:"",
        authOtpAttempt:0
      });
     }
     this.isAuthenticate();
    } else if (
      res.data &&
      res.data.code === 400 &&
      getNestedObject(res, ["data", "message"]).includes("Authentication")
    ) {
      this.isAuthenticate();
      this.showError("common.errors.authenticationError");
    } 
    else if(res.status === 401 && res.data.code === 401 && res.data.message === 'Session has timed out'){
      this.showError("common.errors.sessionTimedOut");
      this.setState({
        screen:1,
        verificationCode:"",
        userName: "",
        password: ""
      });
      this.isAuthenticate();
    }
    else if(res.status === 200 && res.data && typeof res.data === 'string'){
      pageNotFound(res);
    }
    else {
      this.showError("common.errors.loginApiError");
    }
  }

  checkRememberDevice = (params) =>{
    const {spEntityID, goto} = params;
    if(spEntityID){
      http(
        {
          url: `endpoint/appPreferences?spentityid=${spEntityID}`,
          method: "GET"
        }
      ).then((res) => {
        if(res && res.data){
          var deviceProfilesEnabled = res.data.DEVICE_PROFILES_ENABLED;
          if(deviceProfilesEnabled && deviceProfilesEnabled.toUpperCase() === "FALSE"){
            this.setState({
              rememberDeviceCheckbox:false
            })
          }else {
            this.setState({
              rememberDeviceCheckbox:true
            })
          }  
        }
      });
    } else if(goto){
      let uri;
      if(goto.indexOf('oauth') > 0){
        let paramstring = goto.split('?')[1];
        let queryString = new URLSearchParams(paramstring);
        if(queryString.has('redirect_uri')){
          uri = queryString.get('redirect_uri');
        }
      }else {
        uri = goto;
      }
      http(
        {
          url: `endpoint/appPreferences?applicationurl=${uri}`,
          method: "GET"
        }
      ).then((res) => {
        if(res && res.data){
          var deviceProfilesEnabled = res.data.DEVICE_PROFILES_ENABLED;
          if(deviceProfilesEnabled && deviceProfilesEnabled.toUpperCase() === "FALSE"){
            this.setState({
              rememberDeviceCheckbox:false
            })
          }else {
            this.setState({
              rememberDeviceCheckbox:true
            })
          }
        }
      });
    }
  }

  
  onLogin = (e) => {
    e.preventDefault();
    const { userName, password, } = this.state;
    if (userName === "" || password === "") {
      this.showError("common.errors.required");
      if(userName === ""){
        this.setState({
          userNameInvalid:true,
          userNameError:"common.errors.usernameEmpty"
        })
      }
      if(password === ""){
        this.setState({
          passwordInvalid:true,
          passwordError:"common.errors.passwordEmpty"
        })
      }
    } else {
      this.setState({
        errorText: ""
      });
      const { loginPayLoad, userName, password } = this.state;
      loginPayLoad.callbacks[0].input[0].value = userName;
      loginPayLoad.callbacks[1].input[0].value = password;
       if(loginPayLoad.callbacks[2]?.type == "ReCaptchaCallback")
      {
      ReactRecaptcha3.getToken().then(
        (token) => {
          if (token) {
            loginPayLoad.callbacks[2].input[0].value = token;
            http(
              {
                url: this.getAuthenticateUrl(),
                method: "POST",
                data: loginPayLoad,
              },
              {
                "Accept-API-Version": "protocol=1.0,resource=2.1",
              }
            ).then((res) => {
              this.genericResponse(res);
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    else {
        http(
          {
            url: this.getAuthenticateUrl(),
            method: "POST",
            data: loginPayLoad,
          },
          {
            "Accept-API-Version": "protocol=1.0,resource=2.1",
          }
        ).then((res) => {
          this.genericResponse(res);
        });
      }
    }
  };

  getAuthenticateUrl = () => {
    const {
      location: { search }
    } = this.props;
    const { appendParamsToApiUrl, serviceType } = this.state;
    if (appendParamsToApiUrl && serviceType !== '') {
      const serviceValue = `&authIndexType=service&authIndexValue=${serviceType}`;
      return appendParamsToApiUrl ? `authenticate${search}${serviceValue}` : `authenticate`;
    } else {
      return appendParamsToApiUrl ? `authenticate${search}` : `authenticate`;
    }
  };

  showError = (errorText) => {
    this.setState({
      errorText
    });
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
  };

  PasswordValidation = (e) => {
    const {
      target: { value }
    } = e;
    if (value.match(/^[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]*$/)) {
      this.setState({
        password: value
      });
    }
  };

  onNextMFA = (e) => {
      e.preventDefault();
    const { selectedOption, verificationPayLoad } = this.state;
    if(selectedOption === 'userPhone'){
      verificationPayLoad.callbacks[1].input[0].value = 1;
    } else {
      verificationPayLoad.callbacks[1].input[0].value = 0;
    }
    this.setState({
      errorText: ""
    });
    http(
      {
        url: this.getAuthenticateUrl(),
        method: "POST",
        data: verificationPayLoad
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      this.genericResponse(res);
    });
  };

  changeMethod = (e) => {
    e.preventDefault();
    const { verificationPayLoad } = this.state;
    verificationPayLoad.callbacks[3].input[0].value = 2;
    this.setState({
      verificationCode:"",
      verificationCodeError:"",
      errorText:"",
      selectedChoice:"0",
      authenticateChoice:"",
      phoneChoice:"",
      smsChoice:"",
      emailChoice:"",
      
    });
    http(
      {
        url: this.getAuthenticateUrl(),
        method: "POST",
        data: verificationPayLoad
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      this.genericResponse(res);
    });
  };

  onVerify = (e) => {
    e.preventDefault();
    const { verificationCode,verificationPayLoad } = this.state;
      verificationPayLoad.callbacks[2].input[0].value = verificationCode;
      verificationPayLoad.callbacks[3].input[0].value = 0;
    if (verificationCode === "") {
      this.setState({
        verificationCodeError: "pages.login.verificationCodeRequired"
      });
    } else {
      this.verificationInputRef.current.__clearvalues__();
      this.setState({
        verificationCodeError: ""
      });
      http(
        {
          url: this.getAuthenticateUrl(),
          method: "POST",
          data: verificationPayLoad
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        this.genericResponse(res);
      });
    }
  };
  deviceCheck = async() => {
    const {verificationPayLoad } = this.state;
    const deviceId = new FRDevice();
    const profile =  await deviceId.getProfile({
      location:false,
      metadata:true
    })
    verificationPayLoad.callbacks[0].input[0].value = JSON.stringify(profile);
    http(
      {
        url: this.getAuthenticateUrl(),
        method: 'POST',
        data: verificationPayLoad,
      },
      {
        'accept-api-version': 'protocol=1.0,resource=2.1',
        'Content-Type': 'application/json',
      }
    ).then((res) => {
      this.genericResponse(res);
    });
  }
  chooseVerify = (e,value) => {
    e.preventDefault();
    const { verificationPayLoad } = this.state;
    verificationPayLoad.callbacks[0].input[0].value = value;
      http(
        {
          url: this.getAuthenticateUrl(),
          method: "POST",
          data: verificationPayLoad
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        this.genericResponse(res);
      });

  };

  skipUrl = (e) => {
    e.preventDefault();
    const { verificationPayLoad } = this.state;
    if(verificationPayLoad.callbacks[0].output[0].value === 'OTP_COLLECTOR_SKIP'){
      verificationPayLoad.callbacks[3].input[0].value = 2;
    }
    else if(verificationPayLoad.callbacks[0].output[0].value === 'TELEPHONENUMBER_COLLECTOR'){
      verificationPayLoad.callbacks[2].input[0].value = 1;
    } else if(verificationPayLoad.callbacks[0].output[0].value === 'MFA_REGISTRATION_CHOICE'){
      verificationPayLoad.callbacks[0].input[0].value = 4;
    } else if(verificationPayLoad.callbacks[0].output[0].value === 'AUTHENTICATOR_PROMPT'){
      verificationPayLoad.callbacks[0].input[0].value = 2;
    }
      http(
        {
          url: this.getAuthenticateUrl(),
          method: "POST",
          data: verificationPayLoad
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        this.genericResponse(res);
      });
  };

  sendOTP = (e) => {
    e.preventDefault();
    const { mobileNumber} = this.state;
    if (mobileNumber === "") {
      this.setState({
        mobileNumberError: "pages.editNumberPopup.mobileNumberRequired"
      });
      this.mobileNumberInputRef.current.focus();
    } else if (mobileNumber.length < 14) {
      this.setState({
        mobileNumberError: "pages.editNumberPopup.mobileNumberInvalid"
      });
      this.mobileNumberInputRef.current.focus();
    } else {
      this.setState(
        {
          mobileNumberError: "",
          mobileNumberUSFormatted: getPhoneNumberFromFormattedString(
            mobileNumber
          )
        },
        () => {
          this.getOtp();
        }
      );
    }
  }
    
    getOtp = () => {
      const { mobileNumberUSFormatted,verificationPayLoad } = this.state;
      verificationPayLoad.callbacks[1].input[0].value = mobileNumberUSFormatted;
      http(
        {
          url: this.getAuthenticateUrl(),
          method: "POST",
          data: verificationPayLoad
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        this.genericResponse(res);
      });
    };

    onMobileNumberChange = (e) => {
      const currentValue = e.target.value.trim();
      this.setState((prevState) => ({
        ...prevState,
        mobileNumber: formatPhoneNumber(currentValue, prevState.phoneNumber)
      }));
    };

  handleKeyPress = (e) => {
    preventNonDigitCharacters(e);
  };
  handleChange = (vals) => {
    this.setState({
      verificationCode:vals
    })
  };

  onOptionsChange = (value) => {
    if(value.includes("@")){
      value = 'userEmail'
    } else {
      value = 'userPhone'
    }
    this.setState({
      selectedOption:value
    });

  };
  onChoiceChange = (value)=>{
    this.setState({
      selectedChoice:value
    })
  }

  HandleEnterKey = (e) => {
    if(e.keyCode === 13){
      this.setState((state) => ({
        showPassword: !state.showPassword
      }));
    }
  }
  promptRegHandler = (e) =>{
    e.preventDefault();
    const {verificationPayLoad} = this.state;
    let val = parseInt(e.target.value,10);
    verificationPayLoad.callbacks[0].input[0].value=val;
    http(
      {
        url: this.getAuthenticateUrl(),
        method: "POST",
        data: verificationPayLoad
      },
      {
        "Accept-API-Version": "protocol=2.1,resource=1.0"
      }
    ).then((res) => {
      this.genericResponse(res);
    });  
  }
  saveDeviceHandler = () =>{
    const {verificationPayLoad, rememberDevice} = this.state;
    let val = rememberDevice ? 0 : 1
    verificationPayLoad.callbacks[0].input[0].value=val;
    http(
      {
        url: this.getAuthenticateUrl(),
        method: "POST",
        data: verificationPayLoad
      },
      {
        "Accept-API-Version": "protocol=2.1,resource=1.0"
      }
    ).then((res) => {
      this.genericResponse(res);
    });  
  }
  onContinueHandler = (e)=>{
    e.preventDefault();
    const {verificationPayLoad,selectedChoice} = this.state;
    if(verificationPayLoad.callbacks[0].output[0].value === 'MFA_REGISTRATION_CHOICE' || verificationPayLoad.callbacks[0].output[0].value === 'MFA_USER_CHOICE_PROMPT'){
      verificationPayLoad.callbacks[0].input[0].value=selectedChoice;
    } else if(verificationPayLoad.callbacks[0].output[0].value === 'AUTHENTICATOR_PROMPT'){
      verificationPayLoad.callbacks[0].input[0].value=0;
    }
    http(
      {
        url: this.getAuthenticateUrl(),
        method: "POST",
        data: verificationPayLoad
      },
      {
        "Accept-API-Version": "protocol=2.1,resource=1.0"
      }
    ).then((res) => {
      this.genericResponse(res);
    }); 
  }
  checkChoices = (item,index) => {
    let key = index.toString(10)
    if(item.includes('AUTHENTICATOR')){
      this.setState({
        authenticateChoice:key
      })
    }else if(item.includes('SMS')){
      let maskphone;
      if(item.includes('_')){
        maskphone = item.split('_')[1];
      } else{
        maskphone = false;
      }
      this.setState({
        smsChoice:key,
        userPhone:maskphone
      })
    } else if(item.includes('CALL')){
      this.setState({
        phoneChoice:key
      })
    } else if(item.includes('EMAIL')){
      this.setState({
        emailChoice:key,
        userEmail:item.split('_')[1]
      })
    }
  }
  onCopyHandler = (e) =>{
    e.preventDefault();
    let code = document.getElementById('qrcode');
    code.select();
    code.setSelectionRange(0,99999);
    navigator.clipboard.writeText(code.value);
  }
  onAuthenticateOtp = (e) =>{
    e.preventDefault();
    const { verificationCode,verificationPayLoad } = this.state;
    console.log(verificationCode,verificationPayLoad);
      verificationPayLoad.callbacks[0].input[0].value = verificationCode;
      verificationPayLoad.callbacks[1].input[0].value = 0;
    if (verificationCode === "") {
      this.setState({
        verificationCodeError: "pages.login.verificationCodeRequired"
      });
    } else {
      this.verificationInputRef.current.__clearvalues__();
      this.setState({
        verificationCodeError: ""
      });
      http(
        {
          url: this.getAuthenticateUrl(),
          method: "POST",
          data: verificationPayLoad
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        this.genericResponse(res);
      });
    }
  }
  onSwitchHandler = (e) =>{
    e.preventDefault();
    const {verificationPayLoad} = this.state;
    verificationPayLoad.callbacks[1].input[0].value=1;
    this.setState({
      verificationCode:"",
      verificationCodeError:"",
      errorText:"",
      selectedChoice:"0",
      authenticateChoice:"",
      emailChoice:"",
      phoneChoice:"",
      smsChoice:""
    })
    http(
      {
        url: this.getAuthenticateUrl(),
        method: "POST",
        data: verificationPayLoad
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      this.genericResponse(res);
    });
  }
  onBackHandler = (e) =>{
    e.preventDefault();
    const {verificationPayLoad}=this.state;
    verificationPayLoad.callbacks[0].input[0].value = 1;
    this.setState({
      selectedChoice:"0",
      authenticateChoice:"",
      emailChoice:"",
      phoneChoice:"",
      smsChoice:""
    })
    http(
      {
        url: this.getAuthenticateUrl(),
        method: "POST",
        data: verificationPayLoad
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
      this.genericResponse(res);
    });
  }
  onRedirectToProfileHandler = (e) =>{
    e.preventDefault();
    const { verificationPayLoad } = this.state;
    http(
      {
        url: this.getAuthenticateUrl(),
        method: "POST",
        data: verificationPayLoad
      },
      {
        "Accept-API-Version": "protocol=2.1,resource=1.0"
      }
    ).then((res) => {
      this.genericResponse(res);
    }); 
  }
  isFormValid=(e,key)=>{
    const value = e.target ? e.target.value.trim() : e;
      if(key === 'passwordValid'){
        if(value.length === 0){
          this.setState({
            passwordInvalid:true,
            passwordError:"common.errors.passwordEmpty"
          })
        }else{
          this.setState({
            passwordInvalid:false,
            passwordError:""
          })
        }
      }
      if(key === 'usernameValid'){
        if(value.length === 0){
          this.setState({
            userNameInvalid:true,
            userNameError:"common.errors.usernameEmpty"
          })
        }else{
          this.setState({
            userNameInvalid:false,
            userNameError:""
          })
        }
        
      } 
  }
  handleRememberDevice = (value) =>{
    this.setState({
      rememberDevice:value
    })
  }
  seeMoreHandler = () =>{
    this.setState({
      seeMore:!this.state.seeMore
    })
  }
  render() {
    const { t } = this.props;
    const {
      showPassword,
      errorText,
      userName,
      password,
      isAuthenticated,
      isSystemError,
      isSomethingError,carouselImages,imageIndex,
      screen,
      verificationCodeError,
      numberFocus,
      mobileNumber,
      mobileNumberError,
      screenWithSkip,
      verificationOption,
      loginAttempts,
      loginAttemptsCount,
      loginLastAttempts,verificationPlaceholder,
      userEmail,userPhone,selectedOption,switchMethod,authenticateChoice,
      phoneChoice,
      smsChoice,
      emailChoice,
      selectedChoice,
      qrCodeUrl,
      aplhaNumericCode,
      authOtpAttempt,
      mfaReg,
      prefMfa,
      requiresMfa,
      userNameInvalid,
      passwordInvalid,
      userNameError,
      passwordError,
      rememberDevice,
      showCheckbox,
      seeMore,
      phoneSuccess,
      rememberDeviceCheckbox
    } = this.state;
    return (
      
      <>
        {isAuthenticated && !isSystemError && !isSomethingError && (
          <div className={`has-background login-background ${errorText && "has-error"}`} style={{ backgroundImage: `url(${carouselImages[imageIndex].image})` }}>
            <div className="login wrapper">
            {errorText && <WithError errors={errorText} />}
              <Container
                className={`container wrapper__container ${
                  errorText && "haserror"
                }`}
              >
                <Row>
                  <Col lg={{ span: 4 }}>
                    {screen === 1 && (
                      <>
                      <div className="wrapper__container-card">
                      <div className="wrapper__container-card-body">
                        <h1 className="wrapper__container-card-body-title">
                          {t("pages.login.login")}
                        </h1>
                        <Form>
                          <Form.Group controlId="loginEmail">
                            <Form.Label>
                              {t("pages.login.userNameEmail")}
                            </Form.Label>
                            <Form.Control
                              type="email"
                              autoFocus
                              onChange={(e) => {
                                this.setState({
                                  userName: e.target.value.trim()
                                });
                              }}
                              onBlur={(e)=>{this.isFormValid(e,"usernameValid")}}
                              className={userNameInvalid ? 'error-input' : undefined}
                              value={userName}
                              aria-required
                            />
                            <p className="error-text" id="username-error">
                              {userNameInvalid && t(userNameError)}
                            </p>
                          </Form.Group>
                          <Form.Group
                            className="password-field"
                            controlId="loginPassword"
                          >
                            <Form.Label>{t("pages.login.password")}</Form.Label>
                            <Form.Control
                              type={showPassword ? "text" : "password"}
                              onChange={(e) => {
                                this.PasswordValidation(e);
                              }}
                              className={passwordInvalid ? 'error-input': undefined}
                              onBlur={(e)=>{this.isFormValid(e,"passwordValid")}}
                              value={password}
                              aria-required
                              autoComplete="off"
                            />
                            <span
                              className={
                                showPassword ? "eye-icon show" : "eye-icon"
                              }
                              role="button"
                              tabIndex="0" aria-label={showPassword ? t("pages.login.hidePassword") : t("pages.login.showPassword")}
                              onClick={() => this.showPassword()}
                              onKeyDown={(e) => this.HandleEnterKey(e)}
                            />
                            <p className="error-text" id="password-error">
                              {passwordInvalid && t(passwordError)}
                            </p>
                          </Form.Group>
                          <div className="mb-4 wrapper__container-card-body-forgot">
                            {t("pages.login.forgotYour")}{" "}
                            <Link to={`${getRoutePath}/forgotusername`} aria-label={t("pages.login.ForgotUserNameLabel")}>
                              {t("pages.login.userName")}
                            </Link>{" "}
                            {t("pages.login.or")}{" "}
                            <Link to={`${getRoutePath}/passwordreset`} aria-label={t("pages.login.ForgotPassword")}>
                              {t("pages.login.sPassword")}
                            </Link>
                            ?
                          </div>
                          <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => this.onLogin(e)}
                          >
                            {t("pages.login.login")}
                            <img src={RightArrow} alt="" />
                          </Button>
                        </Form>
                      </div>
                      {/* <div className="separator" /> */}
                      <div className="text-center wrapper__container-card-register">
                        {t("pages.login.needAnAccount")}{" "}
                        <Link to={`${getRoutePath}/registration`} aria-label={t("pages.login.signUpLabel")}>
                          {t("pages.login.registerNow")}
                        </Link>
                      </div>
                    </div>
                    </>
                    )}
                    {screen === 2 && (
                      <>
                      <div className="wrapper__container-card">
                      <div className="wrapper__container-card-body">
                        <h1 className="wrapper__container-card-body-title">
                          {t("pages.login.verifyAccount")}
                        </h1>
                        {loginAttempts && (
                          <div className="popup__wrapper-body-pleasenote">
                            <p className="popup__wrapper-body-pleasenote-sp login-attempts">
                             {t("pages.login.attemptsLeft")}{" "}
                                  {loginAttemptsCount}{" "}
                                  {t("pages.login.attempts")}{" "}
                                  {t("pages.login.accountLock")}
                            </p>
                          </div>
                        )}
                        {loginLastAttempts && (
                          <div className="popup__wrapper-body-pleasenote">
                          <p className="popup__wrapper-body-pleasenote-sp login-attempts">
                          {t("pages.login.lastAttempt")}
                          </p>
                        </div>
                        )}
                        {requiresMfa && (
                          <div className="popup__wrapper-body-pleasenote">
                            <span className="popup__wrapper-body-pleasenote-fp">
                            {t("pages.login.pleaseNote")}
                            </span>
                            <span className="pleasenote-sp">
                            {t("pages.login.requiresMfa")}
                            </span>
                          </div>
                        )} 
                        
                        <div className={"popup__wrapper-body-resend " + (verificationOption.includes("@") ? 'popup__wrapper-body-mobile-icon' : 'popup__wrapper-body-email-icon')}>

                        <p className="wrapper__container-card-body-desc">
                          {t("pages.forgotUserName.enterTheVerificationCode")} {verificationOption}
                        </p>
                        <p
                          className="popup__wrapper-body-resend-btn"
                          onClick={(e) => this.resendOTP(e)}
                          role="button"
                          tabIndex={0}
                        >
                          {t("pages.editNumberPopup.resendVerificationCode")}
                        </p>
                        </div>
                        <Form>
                          {rememberDeviceCheckbox && (<div className="rememberDevice">
                            <Checkbox
                              name="Remember Device"
                              aria-label="pages.login.rememberDevice"
                              label="pages.login.rememberDevice"
                              isChecked={rememberDevice}
                              handleChange={this.handleRememberDevice}
                              labelAlignment="right"
                            />
                          </div>)}  
                        <Form.Group controlId="verificationCode" className="verificationCode">
                        <Form.Label>
                          {t("pages.editNumberPopup.verificationCode")}
                        </Form.Label>
                        <ReactCodeInput fields={8} ref={this.verificationInputRef}
                          placeholder={verificationPlaceholder}
                          className={`verification-input
                            ${verificationCodeError ? "error-verification" : undefined}`
                          }
                          onChange={this.handleChange}
                          removeDefaultStyles={true}
                          autoFocus={false}
                          />
                        {verificationCodeError && (
                          <p className="error-text" id="verification-error">
                            {verificationCodeError && t(verificationCodeError)}
                          </p>
                        )}
                      
                      </Form.Group>
                      
                      <div className="popup__wrapper-body-pleasenote">
                        <span className="popup__wrapper-body-pleasenote-fp">
                        {t("pages.login.pleaseNote")}
                        </span>
                        <span className="popup__wrapper-body-pleasenote-sp">
                        {t("pages.login.doNotClose")}
                        </span>
                      </div>
                      <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => this.onVerify(e)}
                          >
                            {t("pages.login.verify")}
                      </Button>
                      {screenWithSkip && (
                        <div className="text-center wrapper__container-card-register">
                        <p
                        className="summary-link"
                        role="button"
                        tabIndex={0}
                        onClick={(e) => this.skipUrl(e)}
                        onKeyPress={(e) => this.skipUrl(e)}
                      >
                        {t("pages.registration.skip")}
                      </p> 
                      </div>
                      )}
                      </Form>
                      </div>
                    </div>
                      </>
                    )}
                    {screen === 3 && (
                      <>
                      <div className="wrapper__container-card">
                      <div className="wrapper__container-card-body">
                        <h1 className="wrapper__container-card-body-title">
                          {t("pages.login.updateMobileNumber")}
                        </h1>
                        <div className="popup__wrapper-body-pleasenote phone-number-yellow-content">
                            <p className="popup__wrapper-body-pleasenote-sp login-attempts">
                            <span>{t("pages.login.choosePhone")}</span>
                            <br></br>
                            <span>{t("pages.forgotUserName.standardRates")}</span>
                            </p>
                        </div>
                       
                        <Form>
                        <Form.Group controlId="mobileNumber">
                        <Form.Label>
                          {t("pages.login.phoneNumber")}
                        </Form.Label>
                        
                        <Form.Control
                          ref={this.mobileNumberInputRef}
                          className={
                            mobileNumberError ? "error-input" : undefined
                          }
                          onKeyDown={this.handleKeyPress}
                          placeholder={!numberFocus ? "(###) ###-####" : ""}
                          onFocus={() => {
                            this.setState({
                              numberFocus: true
                            });
                          }}
                          onBlur={() => {
                            this.setState({
                              numberFocus: false
                            });
                          }}
                          onChange={this.onMobileNumberChange}
                          value={mobileNumber}
                          autoFocus
                          aria-required
                          aria-invalid={!!mobileNumberError}
                          aria-describedby="mobile-number-error"
                        />
                      </Form.Group>
                      {mobileNumberError && (
                        <p className="error-text mobile-number-error" id="mobile-number-error">
                        {mobileNumberError && t(mobileNumberError)}
                      </p>
                      )}
                      
                      
                      <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => this.sendOTP(e)}
                          >
                            {t("pages.login.sendOTP")}
                      </Button> 
                      <div className="text-center wrapper__container-card-register">
                          <p
                        className="summary-link"
                        role="button"
                        tabIndex={0}
                        onClick={(e) => this.skipUrl(e)}
                        onKeyPress={(e) => this.skipUrl(e)}
                      >
                         {t("pages.registration.skip")}
                      </p> 
                      </div>
                      </Form>
                      </div>
                    </div>
                      </>
                    )}

                    {screen === 4 && (
                      <>
                      <div className="wrapper__container-card">
                      <div className="wrapper__container-card-body">
                        <h1 className="wrapper__container-card-body-title">
                          {t("pages.login.verifyMobile")}
                        </h1>
                        <p className="phone-number-not-added wrapper__container-card-body-desc">
                          {t("pages.login.phoneNumberProfile")}
                        </p>
                        <div className="popup__wrapper-body-pleasenote phone-number-yellow-content">
                            <p className="popup__wrapper-body-pleasenote-sp login-attempts">
                            {t("pages.login.choosePhone")}
                            </p>
                        </div>
                        
                        <Form>

                        <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => this.chooseVerify(e,0)}
                          >
                            {t("pages.login.verifyNow")}
                      </Button>
                      <div className="text-center wrapper__container-card-register">
                          <p
                        className="summary-link"
                        role="button"
                        tabIndex={0}
                        onClick={(e) => this.chooseVerify(e,1)}
                        onKeyPress={(e) => this.chooseVerify(e,1)}
                      >
                         {t("pages.login.verifyLater")}
                      </p> 
                      </div>
                      </Form>
                     
                      </div>
                    </div>
                      </>
                    )}
                    {screen === 5 && (
                      <>
                      <div className="wrapper__container-card">
                      <div className="wrapper__container-card-body">
                        <h1 className="wrapper__container-card-body-title">
                          {t("pages.login.verifyAccount")}
                        </h1>
                        <p className="wrapper__container-card-body-desc">
                          {t("pages.login.verificationMethod")}
                        </p>
                        <div>
                        <Radio
                              key={userPhone}
                              name={userPhone}
                              label={`${t("pages.login.smsCode")}${" "}${userPhone}`}
                              value={userPhone}
                              isChecked={selectedOption === 'userPhone' ? true : false}
                              handleChange={this.onOptionsChange} 
                            />
                            {selectedOption === 'userPhone' && (
                            <div className="popup__wrapper-body-pleasenote">
                              <span className="popup__wrapper-body-pleasenote-fp">
                              {t("pages.forgotUserName.pleaseNote")}
                              </span>
                              <span className="popup__wrapper-body-pleasenote-sp">
                              {t("pages.forgotUserName.standardRates")}
                              </span>
                            </div>
                            )}
                            
                            <Radio
                              key={userEmail}
                              name={userEmail}
                              label={`${t("pages.login.emailCode")}${" "}${userEmail}`}
                              value={userEmail}
                              isChecked={selectedOption === 'userEmail' ? true : false}
                              handleChange={this.onOptionsChange} 
                            />    
                              <Button
                      className="wrapper__container-card-body-submit mt-5"
                      size="lg"
                      variant="primary"
                      block
                      type="submit"
                      onClick={(e) => this.onNextMFA(e)}
                    >
                      {t("pages.forgotUserName.verify")}
                    </Button>
                         
                        </div>
                        </div>
                        </div>
                      </>
                    )}
                    {screen === 6 && (
                      <>
                      <div className="wrapper__container-card">
                      <div className="wrapper__container-card-body">
                        <h1 className="wrapper__container-card-body-title">
                          {t("pages.login.verifyAccount")}
                        </h1>
                        {loginAttempts && (
                          <div className="popup__wrapper-body-pleasenote">
                            <p className="popup__wrapper-body-pleasenote-sp login-attempts">
                                  {t("pages.login.attemptsLeft")}{" "}
                                  {loginAttemptsCount}{" "}
                                  {t("pages.login.attempts")}{" "}
                                  {t("pages.login.accountLock")}
                            </p>
                          </div>
                        )}
                        {loginLastAttempts && (
                          <div className="popup__wrapper-body-pleasenote">
                          <p className="popup__wrapper-body-pleasenote-sp login-attempts">
                          {t("pages.login.lastAttempt")}
                          </p>
                        </div>
                        )}
                        
                        <div className={"popup__wrapper-body-resend " + (verificationOption.includes("@") ? 'popup__wrapper-body-mobile-icon' : 'popup__wrapper-body-email-icon')}>

                        <p>
                          {t("pages.forgotUserName.enterTheVerificationCode")}{" "} {verificationOption}
                        </p>
                        <p
                          className="popup__wrapper-body-resend-btn"
                          onClick={(e) => this.resendOTP(e)}
                          role="button"
                          tabIndex={0}
                        >
                          {t("pages.editNumberPopup.resendVerificationCode")}
                        </p>
                        </div>
                        <Form>
                        {rememberDeviceCheckbox && (<div className="rememberDevice">
                          <Checkbox
                            name="Remember Device"
                            aria-label="pages.login.rememberDevice"
                            label="pages.login.rememberDevice"
                            isChecked={rememberDevice}
                            handleChange={this.handleRememberDevice}
                            labelAlignment="right"
                          />
                        </div>)} 
                        <Form.Group controlId="verificationCode">
                        <Form.Label>
                          {t("pages.editNumberPopup.verificationCode")}
                        </Form.Label>
                        <ReactCodeInput fields={8} ref={this.verificationInputRef}
                          placeholder={verificationPlaceholder}
                          className={`verification-input
                            ${verificationCodeError ? "error-verification" : undefined}`
                          }
                          onChange={this.handleChange}
                          removeDefaultStyles={true}
                          autoFocus={false}
                          />
                        {verificationCodeError && (
                          <p className="error-text" id="verification-error">
                            {verificationCodeError && t(verificationCodeError)}
                          </p>
                        )}
                      
                      </Form.Group>
                      
                      <div className="popup__wrapper-body-pleasenote">
                        <span className="popup__wrapper-body-pleasenote-fp">
                        {t("pages.login.pleaseNote")}
                        </span>
                        <span className="popup__wrapper-body-pleasenote-sp">
                        {t("pages.login.doNotClose")}
                        </span>
                      </div>
                      <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => this.onVerify(e)}
                          >
                            {t("pages.login.verify")}
                      </Button>
                      {screenWithSkip && (
                        <div className="text-center wrapper__container-card-register">
                          <p
                        className="summary-link"
                        role="button"
                        tabIndex={0}
                        onClick={(e) => this.skipUrl(e)}
                        onKeyPress={(e) => this.skipUrl(e)}
                      >
                         {t("pages.registration.skip")}
                      </p> 
                      </div>
                      )}
                      {switchMethod && (
                        <div className="switchMethod mt-4">
                        <span>{t("pages.login.havingTrouble")}</span>
                        <span
                        className="summary-link"
                        role="button"
                        tabIndex={0}
                        onClick={(e) => this.changeMethod(e)}
                        onKeyPress={(e) => this.changeMethod(e)}
                      >
                         {t("pages.login.switchMethod")}
                      </span>
                      </div>
                      )}
                      </Form>
                      </div>
                    </div>
                      </>
                    )}
                    {screen === 7 && (
                        <>
                          <div className="wrapper__container-card">
                            <div className="wrapper__container-card-body">
                              <h1 className="wrapper__container-card-body-title">
                              {t("pages.login.TwoFactor")}
                              </h1>
                              <p className="twoFactor-desc wrapper__container-card-body-desc">
                              {t("pages.login.TwoFactorDescription")}
                              </p>
                              <a
                                className="summary-link summary-link-sm"
                                href="https://portal.ct.gov/ctidentity/mfa-faq?language=en_US" target="_blank"
                              >
                                {t("pages.login.readMoreMFA")}
                              </a>
                              <p className="descriptive-content">{t("pages.login.TwoFactorNote")}</p>
                              <Button
                                className="wrapper__container-card-body-submit my-3"
                                size="lg"
                                variant="primary"
                                block
                                type="submit"
                                value="0"
                                onClick={(e) => this.promptRegHandler(e)}
                              >
                                {t("pages.login.Yes")}
                              </Button>
                              <Button
                                className="wrapper__container-card-body-submit my-3"
                                size="lg"
                                variant="primary"
                                block
                                type="submit"
                                value="1"
                                onClick={(e) => this.promptRegHandler(e)}
                              >
                                {t("pages.login.No")}
                              </Button>
                            </div>
                          </div>
                        </>
                    )}
                    {screen === 8 && (
                      <>
                      <div className="wrapper__container-card">
                        <div className="wrapper__container-card-body">
                          <h1 className="wrapper__container-card-body-title">
                            {t("pages.login.TwoFactor")}
                          </h1>
                          {requiresMfa && (
                                <div className="popup__wrapper-body-pleasenote">
                                  <span className="popup__wrapper-body-pleasenote-fp">
                                  {t("pages.login.pleaseNote")}
                                  </span>
                                  <span className="popup__wrapper-body-pleasenote-sp">
                                  {t("pages.login.requiresMfa")}
                                  </span>
                                </div>
                          )} 
                          <p className="wrapper__container-card-body-desc mb-2">
                            {screenWithSkip ? (t("pages.login.authenticationReg")) : t("pages.login.authenticationLogin")}
                          </p>
                          <a
                            className="summary-link summary-link-sm"
                            href="https://portal.ct.gov/ctidentity/mfa-faq?language=en_US" target="_blank"
                          >
                            {t("pages.login.readMoreMFA")}
                          </a>
                          <div>
                              {emailChoice && (<Radio
                                key="email"
                                name="email"
                                label={`${t("pages.login.emailChoice")}${" "}(${userEmail})`}
                                value={emailChoice}
                                isChecked={selectedChoice === emailChoice ? true : false}
                                handleChange={this.onChoiceChange} 
                              />)}  
                              {authenticateChoice && (<Radio
                                key="Authenticator"
                                name="Authenticator"
                                label={t("pages.login.authenticateChoice")}
                                value={authenticateChoice}
                                isChecked={selectedChoice === authenticateChoice ? true : false}
                                handleChange={this.onChoiceChange} 
                              />)} 
                              {smsChoice && (<Radio
                                key="sms"
                                name="sms"
                                label={userPhone?`${t("pages.login.smsChoice")}${" "}(${userPhone})`:t("pages.login.smsChoice")}
                                value={smsChoice}
                                isChecked={selectedChoice === smsChoice ? true : false}
                                handleChange={this.onChoiceChange} 
                              />)}
                              {selectedChoice === smsChoice && selectedChoice &&(
                              <div className="popup__wrapper-body-pleasenote standard-rates">
                                <span className="popup__wrapper-body-pleasenote-fp">
                                {t("pages.login.pleaseNote")}
                                </span>
                                <span className="popup__wrapper-body-pleasenote-sp">
                                {t("pages.forgotUserName.standardRates")}
                                </span>
                              </div>
                              )}
                              {phoneChoice && (<Radio
                                key="Phone"
                                name="Phone"
                                label={userPhone?`${t("pages.login.phoneChoice")}${" "}(${userPhone})`:t("pages.login.phoneChoice")}
                                value={phoneChoice}
                                isChecked={selectedChoice === phoneChoice ? true : false}
                                handleChange={this.onChoiceChange} 
                              />)}
                              {selectedChoice === phoneChoice && selectedChoice && (
                              <div className="popup__wrapper-body-pleasenote standard-rates">
                                <span className="popup__wrapper-body-pleasenote-fp">
                                {t("pages.login.pleaseNote")}
                                </span>
                                <span className="popup__wrapper-body-pleasenote-sp">
                                {t("pages.forgotUserName.standardCallRates")}
                                </span>
                              </div>
                              )} 
                              <Button
                                className="wrapper__container-card-body-submit mt-5"
                                size="lg"
                                variant="primary"
                                block
                                type="submit"
                                onClick={(e) => this.onContinueHandler(e)}
                                onKeyPress={(e) => this.onContinueHandler(e)}
                              >
                                {t("pages.identity.continue")}
                              </Button>
                              {screenWithSkip && (<div className="text-center wrapper__container-card-register">
                                <p tabIndex={0} className="summary-link" role="button" onClick={e=>this.skipUrl(e)} onKeyPress={e=>this.skipUrl(e)}>{t("pages.registration.skip")}</p>
                              </div>)}
                          </div>
                        </div>
                      </div>
                      </>
                    )}
                    {screen === 9 && (
                        <>
                          <div className="wrapper__container-card screenNine">
                            <div className="wrapper__container-card-body">
                              <h1 className="wrapper__container-card-body-title">
                              {t("pages.login.authTitle")}
                              </h1>
                              <p className="wrapper__container-card-body-desc mb-3">
                                {t("pages.login.authDesc")}
                              </p>
                              <p className="wrapper__container-card-body-desc mb-1">
                                {t("pages.login.haveAuth")}
                              </p>
                              <ol className="wrapper__container-card-body-desc twoFactor-desc twoFactor-desc-list">
                                <li>{t("pages.login.haveAppDesc")}</li>
                                <li>{t("pages.login.haveAppDescOne")}</li>
                              </ol>
                              <p className="wrapper__container-card-body-desc mb-1">
                                {t("pages.login.noAuth")}
                              </p>
                              <ol className="wrapper__container-card-body-desc twoFactor-desc twoFactor-desc-list">
                                <li>{t("pages.login.haveAppDescTwo")}</li>
                                <li>{t("pages.login.haveAppDescThree")}</li>
                                <li>{t("pages.login.haveAppDescOne")}</li>
                              </ol>
                              <Button
                                className="wrapper__container-card-body-submit"
                                size="lg"
                                variant="primary"
                                block
                                type="submit"
                                onClick={(e) => this.onContinueHandler(e)}
                                onKeyPress={(e) => this.onContinueHandler(e)}
                              >
                                {t("pages.identity.next")}
                              </Button>
                              <div className="text-center">
                                <p tabIndex={0} className="summary-link" role="button" onClick={e=>this.onBackHandler(e)} onKeyPress={e=>this.onBackHandler(e)}>{t("pages.identity.goBack")}</p>
                              </div>
                              <div className="text-center">
                                <p tabIndex={0} className="summary-link" role="button" onClick={e=>this.skipUrl(e)} onKeyPress={e=>this.skipUrl(e)}>{t("pages.profile.cancel")}</p>
                              </div>
                            </div>
                          </div>
                        </>
                    )}
                    {screen === 10 && (
                        <>
                          <div className="wrapper__container-card screenTen">
                            <div className="wrapper__container-card-body">
                              <h1 className="wrapper__container-card-body-title">
                              {t("pages.login.authTitle")}
                              <br></br>
                              {t("pages.login.scanQR")}
                              </h1>
                              <p className="wrapper__container-card-body-desc mb-3">
                                {t("pages.login.authDesc")}
                              </p>
                              <ol className="wrapper__container-card-body-desc twoFactor-desc twoFactor-desc-list">
                                <li className="twoFactor-desc my-3">
                                  {t("pages.login.authDescriptionOne")}
                                </li>
                                <li className="TwoFactor-desc my-3">
                                  {t("pages.login.authDescriptionTwo")}
                                </li>
                                <li className="TwoFactor-desc my-3">
                                  {t("pages.login.authDescriptionThree")}
                                </li>
                              </ol>
                              <div className="qrCode d-flex flex-column align-items-center justify-content-center mb-3">
                                <div className="mb-4">
                                  <QRCode value={qrCodeUrl} size={256} className="desktop"/>
                                  <QRCode value={qrCodeUrl} size={256} className="mobile"/>
                                </div>
                                <div className="copyCode w-100 d-flex justify-content-center mb-4 gap-2">
                                  <input type="text" value={aplhaNumericCode} disabled id="qrcode" className="mx-2"></input>
                                  <button onClick={e=>this.onCopyHandler(e)} title="Copy to Clipboard"><img src={CopyIcon}/>
                                  </button>
                                </div>
                              </div>
                              <Button
                                className="wrapper__container-card-body-submit"
                                size="lg"
                                variant="primary"
                                block
                                type="submit"
                                onClick={(e) => this.onContinueHandler(e)}
                              >
                                {t("pages.identity.next")}
                              </Button>
                            </div>
                          </div>
                        </>
                    )}
                    {screen === 11 && (
                      <>
                      <div className="wrapper__container-card screenEleven">
                      <div className="wrapper__container-card-body">
                        <h1 className="wrapper__container-card-body-title">
                        {switchMethod ? t("pages.login.verifyAccount") : t("pages.login.authTitle")}
                          <br></br>
                        {/* {switchMethod ? "" : t("pages.login.authTitle")} */}
                        </h1>
                        <div className="popup__wrapper-body-resend popup__wrapper-body-email-icon">
                          <p className="wrapper__container-card-body-desc mb-3">{t("pages.login.authOtpDescription")}</p>
                        </div>
                        <Form>
                        {rememberDeviceCheckbox && (<div className="rememberDevice">
                          <Checkbox
                            name="Remember Device"
                            aria-label="pages.login.rememberDevice"
                            label="pages.login.rememberDevice"
                            isChecked={rememberDevice}
                            handleChange={this.handleRememberDevice}
                            labelAlignment="right"
                          />
                        </div>)} 
                        <Form.Group controlId="verificationCode" className="verificationCode">
                        <Form.Label>
                          {t("pages.editNumberPopup.verificationCode")}
                        </Form.Label>
                        <ReactCodeInput fields={6} ref={this.verificationInputRef}
                          placeholder={verificationPlaceholder}
                          className={`verification-input
                            ${verificationCodeError || (authOtpAttempt > 1) ? "error-verification" : undefined}`
                          }
                          onChange={this.handleChange}
                          removeDefaultStyles={true}
                          autoFocus={false}
                          />
                        {verificationCodeError && (
                          <p className="error-text" id="verification-error">
                            {verificationCodeError && t(verificationCodeError)}
                          </p>
                        )}
                        {authOtpAttempt > 1 && (
                          <p className="error-text" id="verification-error">
                            {t("pages.forgotUserName.invalidVerificationCode")}
                          </p>
                        )}
                      </Form.Group>
                      
                      <div className="popup__wrapper-body-pleasenote">
                        <span className="popup__wrapper-body-pleasenote-fp">
                        {t("pages.login.pleaseNote")}
                        </span>
                        <span className="popup__wrapper-body-pleasenote-sp">
                        {t("pages.login.doNotClose")}
                        </span>
                      </div>
                      <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => this.onAuthenticateOtp(e)}
                          >
                            {t("pages.login.verify")}
                      </Button>
                      { switchMethod && (
                      <div className="text-center mt-4 switchMethod">
                          <span>{t("pages.login.havingTrouble")}</span>
                          <span className="summary-link" role="button" tabIndex={0} onClick={e=>this.onSwitchHandler(e)} onKeyPress={e=>this.onSwitchHandler(e)}>{t("pages.login.switchMethod")}</span>
                      </div>)}
                      </Form>
                      </div>
                    </div>
                      </>
                    )}
                    {screen === 12 && (
                      <>
                      <div className="wrapper__container-card">
                        <div className="wrapper__container-card-body"> 
                          <h1 className="wrapper__container-card-body-title has-desc">
                            {t("pages.login.TwoFactor")}
                          </h1>
                          <div
                            className="success__card"
                            role="alert"
                            aria-live="polite"
                          >
                            {mfaReg === "true" && <p className="success__card-text mb-2">
                              {t("pages.login.mfaSuccess")}
                            </p>}
                            {mfaReg === "false" && <p className="success__card-text mb-2">
                              {t("pages.login.mfaMsgOne") + " "}<span className="text-decoration-bold">{t("pages.login.not")}</span>{" " + t("pages.login.mfaMsgTwo")}
                            </p>}
                            {mfaReg === "true" && prefMfa && <p className="success__card-text my-2">
                              {t("pages.login.mfaPrefStart") + " "} <span className="text-decoration-bold">{t(prefMfa)}</span>{" " + t("pages.login.mfaPrefEnd")}
                            </p>}
                            {/* <p className="success__card-text">
                              {t("pages.login.clickOn")+" "}<span className="text-decoration-bold">{t("pages.identity.continue")}</span>{" "+t("pages.login.redirect")}
                            </p> */}
                          </div>
                        </div>
                        <div className="wrapper__container-card-body">
                          <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="button"
                            onClick={(e) => this.onRedirectToProfileHandler(e)}
                          >
                            {t("pages.identity.continue")}
                          </Button>
                        </div>
                      </div>
                      </>
                    )}
                    {screen === 13 && (
                      <>
                      <div className="wrapper__container-card">
                        <div className="wrapper__container-card-body"> 
                          <h1 className="wrapper__container-card-body-title has-desc">
                            {phoneSuccess ? t("pages.passwordReset.success") : t("pages.passwordReset.failure")}
                          </h1>
                          <div
                            className="success__card"
                            role="alert"
                            aria-live="polite"
                          >
                            {phoneSuccess ? <p className="success__card-text mb-2">
                              {t("pages.login.phoneSuccess")}
                            </p> : <p className="success__card-text mb-2">
                              {t("pages.login.phoneFailure")}
                            </p>}
                          </div>
                        </div>
                        <div className="wrapper__container-card-body">
                          <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="button"
                            onClick={(e) => this.onRedirectToProfileHandler(e)}
                          >
                            {t("pages.identity.continue")}
                          </Button>
                        </div>
                      </div>
                      </>
                    )}
                  </Col>
                  <Col lg={{ span: 8 }} className="login-right-content">
                  
                    <div className="login__right-container">
                    
                      <div className="login__right-container-heading"> {t("pages.login.welcomeText")}</div>
                      <span className={seeMore ? 'login__right-container-service block show': 'login__right-container-service block'}>
                        <span className="login__right-container-subheading">{t("pages.login.serviceTextOne")}</span>
                        {/* <span className="login__right-container-subheading hide">{t("pages.login.serviceTextTwo")}</span> */}
                        <span className="login__right-container-subheading login__right-container-subheading-bold inline-block hide">
                          {t("pages.login.needAnAccount")} 
                          <Link to={`${getRoutePath}/registration`} aria-label={t("pages.login.createOne")}>
                            {t("pages.login.createOne")}
                          </Link>
                        </span>
                      </span>
                      
                      <div className="bottom-section">
                        <div className="separator"></div>
                        <div className="login__right-container-subhead">{t("pages.login.security")}</div>
                        <span className="login__right-container-subcontent block">
                        {t("pages.login.securityDesc")}</span>
                        <a className="login__right-container-link" href="https://portal.ct.gov/ctidentity/mfa-faq?language=en_US" target="_blank" aria-label={t("pages.login.readMore")}>{t("pages.login.readMore")}</a>
                      </div>
                      <p className={seeMore ? 'open see-more mt-3': 'see-more mt-3'} aria-label="" tabIndex={0} role="button" onClick={this.seeMoreHandler} onKeyPress={this.seeMoreHandler}><span className="more">{t("pages.login.seeMore")}</span><span className="less">{t("pages.login.seeLess")}</span><img src={downChevron} alt="down-chevron"></img></p>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
)}
{isSystemError  &&  (
          <SystemDownTime />
        )}
        {isSomethingError  &&  (
          <SomethingWentWrong />
                  
          )}      
          </>
    );
  }
}

Login.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  userDetails: PropTypes.object,
};
Login.defaultProps = {
  userDetails: {},
};
export default withTranslation()(Login);
